import axios from "axios";
const middlewareURL = process.env.REACT_APP_MIDDLEWARE_URL;

axios.defaults.baseURL = middlewareURL;


const getJWT = () => {
  const jwt = window.localStorage.getItem("jwt");
  if (jwt === null) {
    return "";
  } else {
    return jwt;
  }
};
let request = axios.create({
  baseUrl: middlewareURL,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
    Authorization: `Bearer ${getJWT()}`,
  },
});
const Auth = {
  PasswordLogin: (email, Password) =>
    request.patch(`/auth/login/password/${email}`, Password),
  addPublicKey: (id) =>
    request.get(`/auth/addWebauthn/${id}`, {
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt")}`,
      },
    }),
  addWebauthn: (id, data) =>
    request.patch(`/auth/addWebauthn/${id}`, data, {
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt")}`,
      },
    }),
  checkWebauthn: (id) => request.get(`/auth/login/webauthn/${id}`),
  loginWebauthn: (id, data) =>
    request.patch(`/auth/login/webauthn/${id}`, data),
  saveWebAuthn: (id, data) =>
    request.patch(`/auth/savewebauthn/${id}`, data, {
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt")}`,
      },
    }),
};
const User = {
  createUser: (data) =>
    request.post(`/user`, data, {
      headers: {
        
        Authorization: `Bearer ${window.localStorage.getItem("jwt")}`,
      },
    }),
  getUserById: (id) =>
    request.get(`/user/id/${id}`, {
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt")}`,
      },
    }),
  getUserByEmail: (email) =>
    request.get(`/user/email/${email}`, {
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt")}`,
      },
    }),
  getUsers: (page, pageSize) =>
    request
      .get(`/user/${page}`, {
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${window.localStorage.getItem("jwt")}`,
        },
      })
      .then((response) => {
        return response;
      }),
  getUsersGeneric: (data) =>
    request.put(`/user/generic`, data, {
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt")}`,
      },
    }),
  updateUserById: (id, data) =>
    request.patch(`/user/id/${id}`, data, {
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt")}`,
      },
    }),
  updateUserByEmail: (data, email) =>
    request.patch(`/user/email/${email}`, data, {
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt")}`,
      },
    }),
  updateUsersGeneric: (data) =>
    request.patch(`/user/generic`, data, {
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt")}`,
      },
    }),
  addProfile: (id, data) =>
    request.put(`/user/profile/id/${id}`, data, {
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt")}`,
      },
    }),
  updatePassword: (email, password) =>
    request.patch(`/updatepassword/password/${email}`, password, {
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt")}`,
      },
    }),
  // updatePassword: () => request.patch(`/user/password/${email}`, password, { headers: { Authorization: `Bearer ${window.localStorage.getItem('jwt')}` } }),
};
const Client = {
  createClient: (data) =>
    request.post(`/client`, data, {
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt")}`,
      },
    }),
  getClientById: (id) =>
    request.get(`/client/id/${id}`, {
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt")}`,
      },
    }),
  getClientByEmail: (email) =>
    request.get(`/client/email/${email}`, {
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt")}`,
      },
    }),
  getClients: () =>
    request.get("/client", {
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt")}`,
      },
    }),
  getClientsGeneric: (data) =>
    request.put(`/clients/generic`, data, {
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt")}`,
      },
    }),
  updateClientById: (id, data) =>
    request.patch(`/client/id/${id}`, data, {
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt")}`,
      },
    }),
  updateClientByEmail: (data, email) =>
    request.patch(`/client/email/${email}`, data, {
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt")}`,
      },
    }),
  updateClientsGeneric: (data) =>
    request.patch(`/clients/generic`, data, {
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt")}`,
      },
    }),
};
const ProjectPlan = {
  createProjectPlan: (data) =>
    request.post(`/projectplan`, data, {
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt")}`,
      },
    }),
  getProjectPlanById: (id) =>
    request.get(`/projectplan/id/${id}`, {
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt")}`,
      },
    }),
  getProjectPlans: () =>
    request.get("/projectplan", {
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt")}`,
      },
    }),
  updateProjectPlanById: (id, data) =>
    request.patch(`/projectplan/id/${id}`, data, {
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt")}`,
      },
    }),
};
const Evaluation = {
  updateEvaluationById: (id) =>
    request.get(`/evaluation/id/${id}`, {
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt")}`,
      },
    }),
  getEvaluations: () =>
    request.get("/evaluation", {
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt")}`,
      },
    }),
};
const Quote = {
  getQuotes: () =>
    request.get("/qoute", {
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt")}`,
      },
    }),
  updateQuoteById: (id, data) =>
    request.patch(`/quote/id/${id}`, data, {
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt")}`,
      },
    }),
};
const Voucher = {
  getVouchers: () =>
    request.get("/voucher", {
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt")}`,
      },
    }),
};
const Brief = {
  createBrief: (data) =>
    request.post(`/brief`, data, {
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt")}`,
      },
    }),
  getBriefById: (id) =>
    request.get(`/brief/id/${id}`, {
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt")}`,
      },
    }),
  getBriefByReferenceNumber: (referencenumber) =>
    request.get(`/brief/referencenumber/${referencenumber}`, {
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt")}`,
      },
    }),
  getBriefs: () =>
    request.get("/brief", {
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt")}`,
      },
    }),
  getBriefsGeneric: (data) =>
    request.put(`/brief/generic`, data, {
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt")}`,
      },
    }),
  updateBriefById: (id, data) =>
    request.patch(`/brief/id/${id}`, data, {
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt")}`,
      },
    }),
  updateBriefByReferenceNumber: (referencenumber, data) =>
    request.patch(`/brief/referencenumber/${referencenumber}`, data, {
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt")}`,
      },
    }),
  updateBriefGeneric: (data) =>
    request.patch(`/brief/generic`, data, {
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt")}`,
      },
    }),
  deleteBriefById: (id, data) =>
    request.delete(`/brief/id/${id}`, data, {
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt")}`,
      },
    }),
  deleteBriefByReferenceNumber: (referencenumber, data) =>
    request.delete(`/brief/referencenumber/${referencenumber}`, data, {
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt")}`,
      },
    }),
  getBriefByClient: (clientId) =>
    request.get(`/brief/client/${clientId}`, {
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt")}`,
      },
    }),
  getBriefByProfessional: (professionalId) =>
    request.get(`/brief/professional/${professionalId}`, {
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt")}`,
      },
    }),
};
const Project = {
  getProjectById: (id) =>
    request.get(`/project/id/${id}`, {
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt")}`,
      },
    }),
  getProjectByReferenceNumber: (referencenumber) =>
    request.get(`/project/referencenumber/${referencenumber}`, {
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt")}`,
      },
    }),
  getProjects: () =>
    request.get("/project", {
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt")}`,
      },
    }),
  updateProjectById: (id, data) =>
    request.patch(`/project/id/${id}`, data, {
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt")}`,
      },
    }),
  getProjectByClient: (clientId) =>
    request.get(`/project/client/${clientId}`, {
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt")}`,
      },
    }),
  getProjectByProfessional: (professionalId) =>
    request.get(`/project/professional/${professionalId}`, {
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt")}`,
      },
    }),
};
export {
  Auth,
  User,
  Client,
  Evaluation,
  Quote,
  Voucher,
  ProjectPlan,
  Brief,
  Project,
};
